<template>
  <div>
    <Menu mode="horizontal" :active-name="$route.name" @on-select="selectMenu">
      <span style="float: left">
        <a style="margin-left: 24px; margin-right: 24px;" v-on:click="$router.push({ name: 'server' })">
        <Icon type="md-arrow-round-back" size="18" />
      </a>
      </span>
      <MenuItem name="private_cloud_server_detail">
        基本信息
      </MenuItem>
      <MenuItem name="2">
        监控
      </MenuItem>
      <MenuItem name="4">
        控制台
      </MenuItem>
      <MenuItem name="3">
        实例日志
      </MenuItem>
      <MenuItem name="private_cloud_server_operate_log">
        操作日志
      </MenuItem>
    </Menu>
  </div>
</template>

<script>
import ParentView from '@/view/components/parent-view/parent-view'
export default {
  name: 'server-detail-menu',
  components: {ParentView},
  data () {
    return {

    }
  },
  methods: {
    selectMenu (name) {
      this.$router.push({name: name, params: { id: this.$route.params.id }})
    }
  }
}
</script>

<style scoped>

</style>
